import tagHierarchy from "../data/tag-hierarchy.json";

interface TagHierarchyItem {
  name: string;
  tags: string[];
}

interface TagHierarchySubcategory {
  name: string;
  items: TagHierarchyItem[];
}

interface TagHierarchyCategory {
  name: string;
  subcategories: TagHierarchySubcategory[];
}

interface TagHierarchy {
  categories: TagHierarchyCategory[];
}

/**
 * Get all navigation tags from the hierarchy
 */
export function getNavigationTags(): string[] {
  const hierarchy: TagHierarchy = tagHierarchy;
  const allTags: string[] = [];
  
  hierarchy.categories.forEach(category => {
    category.subcategories.forEach(subcategory => {
      subcategory.items.forEach(item => {
        allTags.push(...item.tags);
      });
    });
  });
  
  // Remove duplicates and return sorted
  return [...new Set(allTags)].sort();
}

/**
 * Check if a tag is a navigation tag
 */
export function isNavigationTag(tag: string): boolean {
  const navigationTags = getNavigationTags();
  return navigationTags.includes(tag);
}

/**
 * Get the appropriate color for a tag chip
 */
export function getTagChipColor(tag: string): "info" | "error" | "warning" | "default" {
  if (tag === "sale") {
    return "error";
  }
  if (isNavigationTag(tag)) {
    return "info"; // Material-UI info color is blue
  }
  return "warning";
}